import { AppFunctions } from "@others/AppFunctions.ts"

const DEFAULT_BACKOFFICE_CHAT_AI_CONTROL_URL =
	"https://quinquelarestaurante.com/api/backoffice/chat/ai-control"

export const ExtEndpoints = {
	backofficeChatAiControl:
		AppFunctions.getViteEnv("VITE_BACKOFFICE_CHAT_AI_CONTROL_URL") ||
		DEFAULT_BACKOFFICE_CHAT_AI_CONTROL_URL,
}
